export const YES = 'Yes';
export const NO = 'No';
export const OK = 'Ok';

export const postLaunchErrorMessage = 'Requestor cannot be deleted after launch.';
